import React from "react";
import PropTypes from "prop-types";
import MaterialSelect from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import withStyles from "@material-ui/core/styles/withStyles";
import InputBase from "@material-ui/core/InputBase";
import ArrowDownIcon from "../Icons/ArrowDownIcon";

const Input = withStyles(() => ({
  root: {
    width: `100%`
  },
  input: {
    "padding": `14px 20px 14px 28px`,
    "borderRadius": `6px`,
    "backgroundColor": `#f5f6f6`,
    "fontSize": `20px`,
    "color": `#2a3133`,
    "lineHeight": `1.4`,
    "display": `flex`,
    "align-items": `center`,
    "width": `100%`,
    "boxSizing": `border-box`,
    "&:focus": {
      backgroundColor: `#ebecec`,
      borderRadius: `6px`
    },
    "&:hover": {
      backgroundColor: `#ebecec`,
      borderRadius: `6px`
    }
  }
}))(InputBase);

const SmallInput = withStyles(() => ({
  input: {
    "padding": `2px 30px 2px 8px`,
    "borderRadius": `6px`,
    "backgroundColor": `#f5f6f6`,
    "fontSize": `13px`,
    "color": `#2a3133`,
    "lineHeight": `1.54`,
    "display": `flex`,
    "align-items": `center`,
    "width": `100%`,
    "boxSizing": `border-box`,
    "&:focus": {
      backgroundColor: `#ebecec`,
      borderRadius: `6px`
    },
    "&:hover": {
      backgroundColor: `#ebecec`,
      borderRadius: `6px`
    }
  }
}))(InputBase);

const styles = {
  defaultIcon: {
    marginRight: `20px`
  },
  smallIcon: {
    width: `12px`,
    marginRight: `10px`
  },
  menu: {
    borderRadius: `6px`,
    boxShadow: `0 2px 10px 0 rgba(63, 69, 71, 0.08), 0 0 1px 0 rgba(63, 69, 71, 0.2)`,
    backgroundColor: `#ffffff`
  },
  defaultMenuItem: {
    "fontSize": `20px`,
    "color": `#2a3133`,
    "padding": `14px 20px 14px 28px`,
    "&:hover": {
      backgroundColor: `#fafafa`
    }
  },
  smallMenuItem: {
    "fontSize": `13px`,
    "lineHeight": `1.54`,
    "color": `#2a3133`,
    "padding": `2px 30px 2px 8px`,
    "&:hover": {
      backgroundColor: `#fafafa`
    }
  },
  selected: {
    backgroundColor: `#ebecec !important`,
    fontWeight: `900`
  }
};

function Select(props) {
  const {
    size,
    options,
    renderOption,
    renderFooter,
    classes,
    value: currentValue,
    ...rest
  } = props;
  return (
    <MaterialSelect
      {...rest}
      value={currentValue}
      input={size === `small` ? <SmallInput /> : <Input />}
      IconComponent={ArrowDownIcon}
      classes={{
        icon: classes[`${size || `default`}Icon`]
      }}
      MenuProps={{
        classes: {
          paper: classes.menu
        },
        MenuListProps: {
          disablePadding: true
        }
      }}
    >
      {options.map(({label, value, disabled}) => {
        const selected = currentValue === value;
        return (
          <MenuItem
            key={label}
            disabled={disabled}
            selected={selected}
            value={value}
            classes={{
              root: classes[`${size || `default`}MenuItem`],
              selected: classes.selected
            }}
          >
            {renderOption(label, value)}
          </MenuItem>
        );
      })}
      {renderFooter && renderFooter()}
    </MaterialSelect>
  );
}

Select.propTypes = {
  size: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renderOption: PropTypes.func,
  renderFooter: PropTypes.func,
  options: PropTypes.array,
  classes: PropTypes.object
};

export default withStyles(styles)(Select);
